import i18n from "@/i18n";

export const backgroundFields = [
    {
        key: "name",
        label: i18n.t("common.name"),
        sortable: true
    },
    {
        key: "actions",
        label: ""
    }];
